import { SIQBannerColorTheme } from "./SIQBannerColorTheme";
export class SIQBannerTheme {
  successTheme = new SIQBannerColorTheme();
  infoTheme = new SIQBannerColorTheme();
  failureTheme = new SIQBannerColorTheme();
}
//# sourceMappingURL=SIQBannerTheme.js.map